import React, { lazy } from 'react';
import { HeartPulseIcon, LeafIcon, AlertCircleIcon, ArrowRightIcon } from 'lucide-react';
export function AuthorSection() {
  return <section className="w-full bg-emerald-50 py-16 md:py-24" data-id="element-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center mb-12" data-id="element-22">
          <div data-id="element-23">
            <div className="flex items-center gap-2 mb-4" data-id="element-24">
              <HeartPulseIcon className="w-6 h-6 text-emerald-700" data-id="element-25" />
              <span className="text-emerald-700 font-semibold" data-id="element-26">Your Guide</span>
            </div>
            <div className="flex items-center gap-3 mb-4" data-id="element-27">
              <LeafIcon className="w-8 h-8 text-emerald-700" data-id="element-28" />
              <h2 className="text-3xl md:text-4xl font-bold text-stone-900" data-id="element-29">
                Meet Emily Harper, RH
              </h2>
            </div>
            <p className="text-lg text-stone-700 mb-2" data-id="element-30">
              Registered Herbalist | Family Nutrition Specialist | Mom of 3
            </p>
            <p className="text-base text-emerald-700 font-medium mb-4" data-id="element-31">
              Registered Herbalist with 15+ years of practical herbal wellness
              experience.
            </p>
            <p className="text-lg text-stone-700 mb-6 leading-relaxed" data-id="element-32">
              For 15 years, Emily has helped families, seniors, and busy parents
              treat everyday ailments naturally—using safe, proven herbal
              remedies you can make right in your kitchen.
            </p>
            <p className="text-lg text-stone-700 leading-relaxed" data-id="element-33">
              Her remedies have been featured in homesteading communities,
              naturopathic clinics, and family wellness workshops across the
              U.S.
            </p>
          </div>
          <div data-id="element-34">
            <img src="https://cdn.magicpatterns.com/uploads/4tg3KizLvnmMbJAcXPtYZ9/Natural_remedies_and_herbal_wellness.png" alt="Emily Harper with Natural Remedy Guide" className="w-full h-auto rounded-lg shadow-xl" loading="lazy" data-id="element-35" />
          </div>
        </div>
        <div className="bg-white rounded-xl p-8 shadow-lg" data-id="element-36">
          <div className="flex items-center gap-3 mb-4" data-id="element-37">
            <AlertCircleIcon className="w-8 h-8 text-amber-600" data-id="element-38" />
            <h3 className="text-2xl font-bold text-stone-900" data-id="element-39">
              Her Crisis Moment
            </h3>
          </div>
          <div className="space-y-4 text-stone-700 leading-relaxed" data-id="element-40">
            <p data-id="element-41">
              Three winters ago, Emily's youngest daughter developed chronic
              sinus infections. Nothing seemed to help—not the usual remedies,
              not supplements, not repeated doctor visits.
            </p>
            <p data-id="element-42">
              After months of frustration and little progress, Emily began
              researching herbal traditions and natural remedies used for
              generations.
            </p>
            <div className="flex items-start gap-3 bg-emerald-50 p-4 rounded-lg" data-id="element-43">
              <ArrowRightIcon className="w-6 h-6 text-emerald-700 flex-shrink-0 mt-1" data-id="element-44" />
              <p className="text-xl font-bold text-emerald-700" data-id="element-45">
                She rebuilt her family's wellness using simple remedies from her
                kitchen — not the pharmacy.
              </p>
            </div>
            <p className="font-semibold" data-id="element-46">
              Today, her kids are healthier than ever. Her family relies on
              natural remedies daily. And she's helped thousands of readers do
              the same.
            </p>
          </div>
        </div>
      </div>
    </section>;
}